import template from './viewLaborCategoryModal.html';
import controller from './viewLaborCategoryModal.controller';

let ViewLaborCategoryModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
ViewLaborCategoryModalComponent.template = template;
ViewLaborCategoryModalComponent.controller = controller;

export default ViewLaborCategoryModalComponent;




// WEBPACK FOOTER //
// ./client/common/modals/viewLaborCategoryModal/viewLaborCategoryModal.component.js